import {IRuleset} from "../../../index";
import {AbstractMulti, Step} from "./AbstractMulti";
import {getCancelButton, getContinueButton} from "../../../constants/RouteDefinitions";
import {SPINNER} from "../../../constants";
import PromiseRequest from "../../../req/PromiseRequest";
import {createErrorString} from "../../../util/misc";
import {nsRuleset} from "../nsRuleset";
import pubsub from "../../../pubsub";
import multi_deleteHtml from './multi-delete.html?raw';

export const template = multi_deleteHtml

export class viewModel extends AbstractMulti {

    protected override initButtons() {
        this.pageButtons.add(getCancelButton())

        this.pageButtons.add({
            onClick: () => this.params.dialog.doClose?.(),
            label: () => 'cancel',
            icon: () => 'fa-ban',
            cssClass: 'action',
            validator: () => !this.isStep(Step.Success, Step.Error),
        })

        this.pageButtons.add({
            onClick: () => this.params.dialog.doClose?.(),
            label: 'close',
            icon: 'fa-times',
            cssClass: 'action',
            validator: () => this.isStep(Step.Success, Step.Error),
        })

        this.pageButtons.add(getContinueButton({
            onClick: () => this.step(Step.Process),
            cssClass: 'destructive',
            label: 'yes, continue',
            validator: () => this.isStep(Step.Introduction),
        }))
    }

    protected override onStepChange(step: Step) {
        switch (step) {
            case Step.Introduction:
                this.introMessage = `message: you are about to delete subject|s:((${this.getNumObjectsText(this.selectedObjects)}))`;
                break
        }
        super.onStepChange(step);
    }

    protected getPromiseArray(): (() => Promise<any>)[] {
        return this.selectedObjects.map((item: IRuleset) => () => {
            this.messageData({message: `((deleting)) [${item.name}]... ${SPINNER}`})
            const req = new PromiseRequest('deleteruleset')
            this.requests.push(req)
            return req
                .request({id: item.id})
                .then(() => this.arrSuccess.push(item))
                .catch((reason: string) => this.arrError.push({
                    item: item,
                    error: createErrorString(reason, '_blank')
                }))
        })
    }

    protected onPromiseArraySuccess(): void {
        nsRuleset.invalidateCachesAfterRulesetMutation()
        pubsub.trigger('search.remove.selection')
        pubsub.trigger('search.needs.refresh')
        this.messageData(null)
        this.step(this.Step.Success)
    }

}
